import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { BehaviorSubject, Observable } from 'rxjs';
import * as fromCatalog from '../store';
import { isPlatformServer } from '@angular/common';

@Injectable()
export class ProductsLoadingService {
  private isProductsLoadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  private isCatalogLoadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  private isLoadedOnce = false;

  public get isProductsLoading$(): Observable<boolean> {
    return this.isProductsLoadingSubject.asObservable();
  }

  public get isCatalogLoading$(): Observable<boolean> {
    return this.isCatalogLoadingSubject.asObservable();
  }

  constructor(private store: Store<fromCatalog.CatalogState>, @Inject(PLATFORM_ID) private platformId: Object) {
    if (isPlatformServer(this.platformId)) {
      return;
    }

    this.store.pipe(select(fromCatalog.isProductsLoading))
      .subscribe((isLoading: boolean) => {
        if (this.isLoadedOnce && !isLoading) {
          this.isCatalogLoadingSubject.next(false);
          this.isLoadedOnce = null;
        }

        if (this.isLoadedOnce !== null) {
          this.isLoadedOnce = isLoading;
        }

        this.isProductsLoadingSubject.next(isLoading);
      });
  }
}
